/* eslint-disable no-shadow */
/* eslint-disable eqeqeq */
import React, { useCallback, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { get, sumBy } from 'lodash';
import { Popover, PopoverBody } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import { IncompleteApplicationPopup } from '../../../../../components/PopUps';
import DeleteEventFailedPopup from '../../../../../components/Events/Popups/DeleteEventFailedPopup';
import PopOverMenu from '../../../../../components/PopOverMenu';

import { resetEvent, publishEvent, publishRecurringEvent, unPublishEvent, cloneEvent, deleteEvent, closeDeleteFailedPopup, setJustPublishedFlag } from '../../../../../actions/event-profile-actions';
import { sendGroupSMS, sendSchedulingMessage } from '../../../../../actions/event-actions';
import { showErrorPopup, showInfoPopup } from '../../../../../actions/notification-actions';
import { eventStateTypeIds } from '../../../../../utils/eventConstants';
import { clubs } from '../../../../../../constants';
import { getLabelByTypeId } from '../../../../../utils/types';
import { useStatsig } from '../../../../../components/hooks/useStatsig';
import { canDeleteEvent, isEventType, EventTypes } from '../../../../../utils/events';
import Img from '../../../../../components/Img';
import { getNewClubPath } from '../../../../../utils/clubs';
import { showSplash } from '../../../../../actions/splash-actions';
import RecurringSubmissionPopups from '../../../../../components/Events/EventEditWizard/RecurringSubmissionPopups';
import { useRecurringPublishSelection } from '../../../../../components/Events/EventEditWizard/useRecurringPublishSelection';

import config from '../../../../../../config';
import { routerHistoryShape } from '../../../../../propTypes';
import styles from '../../../event.scss';

const _ = { get, sumBy };

const AdminBarV3 = (props) => {
    const { isCurrentMemberAdmin, isCurrentMemberVolunteer, previewOnly } = props;

    const coreUI = useSelector(({ coreUI }) => coreUI);
    const { event, adminSplash, deleteEventFailed, draws, upcomingRecurringEvents } = useSelector(({ eventProfile }) => {
        const { event, adminSplash, deleteEventFailed, draws, upcomingRecurringEvents } = eventProfile;
        return { event, adminSplash, deleteEventFailed, draws, upcomingRecurringEvents };
    });
    const dispatch = useDispatch();
    const { checkGate, featureGates } = useStatsig();

    const isFlexGroupSmsEnabled = checkGate(featureGates.SEND_FLEX_GROUP_SMS);
    const isSendDrawNotificationsEnabled = checkGate(featureGates.SEND_DRAW_NOTIFICATIONS);
    const isEventDeskDayPlannerEnabled = checkGate(featureGates.EVENT_DESK_DAY_PLANNER);
    const isClubRedirectEnabled = checkGate(featureGates.CLUB_LINKS_REDIRECT);

    const { types: { tms: { tmsEventStates } } } = coreUI;

    const isPaidHitEvent = isEventType(event.data, EventTypes.PAID_HIT);
    const isFreePlayEvent = isEventType(event.data, EventTypes.FREE_PLAY);
    const isFlexLeagueEvent = isEventType(event.data, EventTypes.FLEX_LEAGUE);

    const showAddAttachment = isCurrentMemberAdmin && !previewOnly && event.data && !isPaidHitEvent;
    const canAddWeatherUpdate = isCurrentMemberAdmin && !previewOnly && event.data;
    const showAddPlayer = isCurrentMemberAdmin && !previewOnly && event.data?.published && event.data.canAddPlayer && !isPaidHitEvent;
    const showExportPlayers = isCurrentMemberAdmin && !previewOnly && event.data?.published && event.data.registeredCount > 0 && !isPaidHitEvent;
    const showMessagePlayers = isCurrentMemberAdmin && !previewOnly && event.data?.registeredCount > 0 && !isPaidHitEvent;
    const canAddEligiblePlayers = isCurrentMemberAdmin && !previewOnly && event.data?.preRegAndEligibleListEnabled;
    const canInvitePreRegistrants = isCurrentMemberAdmin && !previewOnly && event.data?.preRegAndEligibleListEnabled;
    const hasRecurringSeries = isCurrentMemberAdmin && !previewOnly && event.data?.hasRecurringSeries;
    const isDraftEvent = event.data && !event.data.published;
    const canPublishRecurringFromProfile = isDraftEvent && hasRecurringSeries;

    const [showRecurringPublishPopup, setShowRecurringPublishPopup] = useState(false);
    const { selection: recurringPublishSelection, seed: seedRecurringPublishSelection, toggleEvent: toggleRecurringPublishEvent, toggleSelectAll: toggleSelectAllRecurringPublish } = useRecurringPublishSelection();

    const getAddPlayerText = () => {
        return isFlexLeagueEvent ? 'sub' : 'player(s)';
    };
    const [incompletePopup, setIncompletePopup] = useState();
    const [publishPopover, setPublishPopover] = useState();

    const handleNavigateToEventDesk = useCallback(() => {
        props.history.push(`/events/${event.data.id}/draws`);
    }, [event.data?.id, props.history]);

    const handleNavigateToEventDeskCheckIn = useCallback(() => {
        props.history.push(`/events/${event.data.id}/draws?v=checkInTab`);
    }, [event.data?.id, props.history]);

    const handleNavigateToEditEvent = useCallback(() => {
        props.history.push(`/events/${event.data.id}/edit`);
    }, [event.data?.id, props.history]);

    const menuItemIds = {
        messagePopup: 1,
        exportRegistrants: 2,
        addAttachment: 3,
        addPlayers: 4,
        weatherUpdate: 5,
        addEligiblePlayers: 6,
        invitePreRegistrants: 7,
    };

    // admin bar menu items

    const adminBarMenuItems = [];
    const actionsMenuItems = [];

    const handleActionMenuClick = (option) => {
        switch (option.value) {
            case menuItemIds.messagePopup:
                props.toggleMessagePopUp(true);
                break;
            case menuItemIds.exportRegistrants:
                props.exportRegistrants();
                break;
            case menuItemIds.addAttachment:
                props.toggleUploadAttachmentPopUp();
                break;
            case menuItemIds.addPlayers:
                props.togglePlayerRegisterPopUp();
                break;
            case menuItemIds.weatherUpdate:
                props.toggleAddWeatherUpdatePopup();
                break;
            case menuItemIds.addEligiblePlayers:
                props.toggleAddEligiblePlayersSidebar();
                break;
            case menuItemIds.invitePreRegistrants:
                props.toggleInvitePreRegistrantsSidebar();
                break;
            default:
                break;
        }
    };

    const messageLabel = `Message players`;
    const exportLabel = `Export players`;
    const addPlayerLabel = `Add ${getAddPlayerText()}`;

    if (showMessagePlayers) {
        actionsMenuItems.push({
            value: menuItemIds.messagePopup,
            label: messageLabel,
        });
    }
    if (showExportPlayers) {
        actionsMenuItems.push({
            value: menuItemIds.exportRegistrants,
            label: exportLabel,

        });
    }

    if (showAddAttachment) {
        actionsMenuItems.push({
            value: menuItemIds.addAttachment,
            label: 'Add attachment',

        });
    }
    if (showAddPlayer) {
        actionsMenuItems.push({
            value: menuItemIds.addPlayers,
            label: addPlayerLabel,
        });
    }
    if (canAddWeatherUpdate) {
        actionsMenuItems.push({
            value: menuItemIds.weatherUpdate,
            label: 'Add weather update',
        });
    }
    if (canAddEligiblePlayers) {
        actionsMenuItems.push({
            value: menuItemIds.addEligiblePlayers,
            label: 'Add eligible player IDs',
        });
    }
    if (canInvitePreRegistrants) {
        actionsMenuItems.push({
            value: menuItemIds.invitePreRegistrants,
            label: 'Invite pre-registrants',
        });
    }

    if (!_.get(event.data, 'isDemoEvent', false)) {
        adminBarMenuItems.push({
            label: 'Duplicate',
            value: 'clone',
        });
    } else {
        adminBarMenuItems.push({
            label: 'Reset Event',
            value: 'reset_event',
        });
    }

    if (event.data?.published) {
        adminBarMenuItems.push({ label: 'Unpublish', value: 'unpublish' });
    }

    if (canDeleteEvent(event)) {
        adminBarMenuItems.push({
            label: 'Delete',
            value: 'delete',
        });
    }

    if (isFlexLeagueEvent && event.data?.published && event.data?.eventDivisions?.length > 0 && isSendDrawNotificationsEnabled) {
        adminBarMenuItems.push({ label: 'Send player match scheduling message', value: 'send_scheduling_message' });
    }

    const hasPublishedDraws = draws?.data?.some(draw => draw.published);

    if (isFlexLeagueEvent && isFlexGroupSmsEnabled && event.data?.published && event.data?.eventDivisions?.length > 0 && hasPublishedDraws) {
        adminBarMenuItems.push({ label: 'Send opponent SMS group texts', value: 'send_group_sms' });
    }

    // admin dropdown & actions

    async function handleCloneEvent() {
        const res = await dispatch(cloneEvent());
        if (res) {
            props.history.push(`/events/${res.id}/edit?cloned=true`);
        }
    }

    async function handleDeleteEvent() {
        const res = await dispatch(deleteEvent());
        if (res) {
            setTimeout(() => {
                if (isClubRedirectEnabled) {
                    dispatch(showSplash());
                    const newClubPath = getNewClubPath(event.data.club.tierTypeId);
                    window.location.href = `${config.nextAppHost}/${newClubPath}/${event.data.club.id}`;
                } else {
                    props.history.push(`/clubs/${event.data.club.id}`);
                }
            }, 1500);
        }
    }

    function handleUnPublishEvent() {
        setPublishPopover(false);
        dispatch(unPublishEvent());
    }

    function handleResetEvent() {
        dispatch(resetEvent());
    }

    const buildRecurringPublishSeed = () => {
        const pendingRecurringEvents = (upcomingRecurringEvents?.data || []).filter(recurrentEvent => recurrentEvent.tmsEventId == null && recurrentEvent.recurrentEventId != null);
        return pendingRecurringEvents.map(recurrentEvent => ({
            ...recurrentEvent,
            id: recurrentEvent.recurrentEventId,
        }));
    };

    function handlePublishClick() {
        if (canPublishRecurringFromProfile) {
            seedRecurringPublishSelection(buildRecurringPublishSeed());
            setShowRecurringPublishPopup(true);
            return;
        }
        togglePublishPopover();
    }

    function handleConfirmRecurringPublish() {
        setShowRecurringPublishPopup(false);
        const recurrentEventPublishSelections = recurringPublishSelection.map(recurrentEvent => ({
            recurrentEventId: recurrentEvent.recurrentEventId,
            publishOnCreate: !!recurrentEvent.publishOnCreate,
        }));
        dispatch(publishRecurringEvent(recurrentEventPublishSelections));
        dispatch(setJustPublishedFlag(true));
    }

    const closeRecurringPublishPopup = useCallback(() => {
        setShowRecurringPublishPopup(false);
    }, []);

    function handlePublishEvent() {
        const clubIsSanctioned = event.data.club ? event.data.club.sanctioned : false;
        const paymentsEnabledForClub = event.data.club ? event.data.club.paymentsEnabled : false;
        const eventDivisionEntryFeeSum = event.data?.eventDivisions ? _.sumBy(event.data.eventDivisions, division => division.entryFee) : 0;
        const eventAllowOffPlatformPayments = event ? event.data.allowOffPlatformPayments : false;

        if (!(event.data.eventDivisions?.length)) {
            dispatch(showErrorPopup({
                message: 'Unable to publish event. Please add at least one Event Division.',
            }));
        } else if (!(event.data.eventLocations?.length)) {
            dispatch(showErrorPopup({
                message: 'Unable to publish event. Please add at least one Event Location.',
            }));
        } else if (!clubIsSanctioned && event.data.utrTypeId === 2) {
            setIncompletePopup(true);
        } else if (!paymentsEnabledForClub && eventDivisionEntryFeeSum > 0 && !eventAllowOffPlatformPayments) {
            dispatch(showErrorPopup({
                message: 'Unable to publish event. An active club payment account is required.',
            }));
        } else {
            dispatch(publishEvent());
            dispatch(setJustPublishedFlag(true));
        }
    }

    function handleHeaderPopoverSelect(option) {
        switch (option.value) {
            case 'clone':
                handleCloneEvent();
                break;
            case 'delete': {
                dispatch(showInfoPopup({
                    title: 'Delete Event',
                    message: 'Deleting this event will mean that no players will be able to search, view or register for this event. You can not retrieve the event in the future.',
                    confirmButtonLabel: 'Delete',
                    onConfirmClick: handleDeleteEvent,
                    showCancelButton: true,
                }));
                break;
            }
            case 'unpublish':
                dispatch(showInfoPopup({
                    title: 'Unpublish Event',
                    message: 'Unpublishing this event will mean that no players will be able to search, view or register for this event. You may re-publish the event in the future.',
                    confirmButtonLabel: 'Unpublish',
                    onConfirmClick: handleUnPublishEvent,
                    showCancelButton: true,
                }));
                break;
            case 'reset_event': {
                dispatch(showInfoPopup({
                    title: 'Reset Event',
                    message: 'This will delete all divisions, draws and post scores from those draws. This action cannot be undone.',
                    confirmButtonLabel: 'Reset',
                    onConfirmClick: handleResetEvent,
                    showCancelButton: true,
                }));
                break;
            }
            case 'send_scheduling_message': {
                dispatch(showInfoPopup({
                    title: 'Send Scheduling Message',
                    message: 'Are you sure you want to trigger text & email messages to all players?',
                    confirmButtonLabel: 'Send',
                    onConfirmClick: handleSendSchedulingMessage,
                    showCancelButton: true,
                }));
                break;
            }
            case 'send_group_sms': {
                dispatch(showInfoPopup({
                    title: 'Send Group SMS',
                    message: 'Are you sure you want trigger the opponent group SMS messages to all published draw match ups?',
                    confirmButtonLabel: 'Send',
                    onConfirmClick: handleSendGroupSms,
                    showCancelButton: true,
                }));
                break;
            }
            default:
                break;
        }
    }

    const handleSendSchedulingMessage = () => {
        dispatch(sendSchedulingMessage(event.data.id));
    };

    const handleSendGroupSms = () => {
        dispatch(sendGroupSMS(event.data.id, { matchIds: [] }));
    };

    function togglePublishPopover() {
        setPublishPopover(!publishPopover);
    }

    function handleEditPopoverClick(option) {
        const step = option.value;
        props.history.push(`/events/${event.data.id}/edit?step=${step}`);
    }

    function determineStepNames() {
        return [
            { value: '1', label: 'Step 1: Format & schedule' },
            { value: '2', label: 'Step 2: Registration divisions' },
            { value: '3', label: 'Step 3: Details' },
            { value: '4', label: 'Step 4: Add sponsors' },
            { value: '5', label: 'Step 5: Health & safety' },
        ];
    }

    const isNotInRegistrationState = event.data.registeredCount > 0 &&
        event.data.eventStateId !== eventStateTypeIds.PRE_REGISTRATION &&
        event.data.eventStateId !== eventStateTypeIds.OPEN_REGISTRATION;

    const isRegistrationStateValid = isEventDeskDayPlannerEnabled || isNotInRegistrationState;

    const showDrawsButton = event.data.published &&
        isRegistrationStateValid &&
        !isPaidHitEvent &&
        !isFreePlayEvent;
    const isRegistrationOpened = getLabelByTypeId(tmsEventStates, event.data?.eventStateId) === 'Open Registration';

    return (
        <>
            <div className={`${styles.section} sub-header ${adminSplash ? 'admin-splash bg-teal' : 'bg-transparent'}`}>
                <div className={`container bg-transparent ${styles.headerStyle}`}>
                    <div className="row">
                        <div className={`col ${styles.contentWrapper} ${styles.headerCol}  justify-content-between`}>
                            <div className={`d-flex gap-16 aic`}>
                                {!event.data.published && !adminSplash && (
                                    <div className={`${styles.draftHeader}`} data-testid="event-profile.admin-bar.draft-header">DRAFT{event.data.utrTypeId === 2 && event.data.club.verificationApplicationStatus === clubs.submittedForApproval ? ' - Pending Verified UTR Rating Approval' : ''}</div>
                                )}
                                {event.data.published && !adminSplash && !isPaidHitEvent && (
                                    <div className={`text-black ${isRegistrationOpened ? styles.registrationOpen : ''}`} data-testid="event-profile.admin-bar.registration-state">{getLabelByTypeId(tmsEventStates, event.data?.eventStateId).toUpperCase()}</div>
                                )}
                                {event.data.isRecurringEvent && (
                                    <div className={styles.gradientPill} data-testid="event-profile.admin-bar.recurring-pill">
                                        <Img src="/img/v4/icon-recurring.svg" />
                                        Recurring Event
                                    </div>
                                )}
                            </div>
                            <div className={`content no-wrap ${styles.contentWrapper}`}>
                                {isCurrentMemberVolunteer ? (
                                    <span
                                        type="button"
                                        className={`${styles.borderLeft}`}
                                        onClick={handleNavigateToEventDeskCheckIn}
                                        data-testid="event-profile.admin-bar.event-desk-btn"
                                    >
                                        Event Desk
                                    </span>
                                ) : (
                                    <>
                                        {!adminSplash && (
                                            < >
                                                {event.data.published && !isPaidHitEvent && (

                                                    <PopOverMenu
                                                        menuItems={actionsMenuItems}
                                                        onSelected={handleActionMenuClick}
                                                        mobileAlignLeft={styles.mobileAlignLeft}
                                                        popOverMenuClass={`d-inline-block`}
                                                        data-testid="event-profile.admin-bar.actions-menu"
                                                    >
                                                        <span className="d-flex align-items-center" data-testid="event-profile.admin-bar.actions-menu-btn">Actions <i className="uts uts-expand mr0" />
                                                        </span>
                                                    </PopOverMenu>
                                                )}
                                                {isPaidHitEvent || isFreePlayEvent ? (
                                                    <div className="">
                                                        <button
                                                            type="button"
                                                            className="text-uppercase"
                                                            onClick={handleNavigateToEditEvent}
                                                            data-testid="event-profile.admin-bar.edit-btn"
                                                        >
                                                            Edit
                                                        </button>
                                                    </div>
                                                ) : (
                                                    <PopOverMenu
                                                        menuItems={determineStepNames()}
                                                        onSelected={handleEditPopoverClick}
                                                        mobileAlignLeft={styles.mobileAlignLeft}
                                                        popOverMenuClass={`d-inline-block`}
                                                        data-testid="event-profile.admin-bar.edit-menu"
                                                    >
                                                        <span className=" d-flex align-items-center" data-testid="event-profile.admin-bar.edit-menu-btn">Edit <i className="uts uts-expand mr0" />
                                                        </span>
                                                    </PopOverMenu>
                                                )}
                                                <div className={`${styles.contentWrapper}`}>

                                                    {adminBarMenuItems && !isFreePlayEvent && (
                                                        <PopOverMenu
                                                            menuItems={adminBarMenuItems}
                                                            onSelected={handleHeaderPopoverSelect}
                                                            mobileAlignLeft={styles.mobileAlignLeft}
                                                            popOverMenuClass={`d-inline-block`}
                                                            data-testid="event-profile.admin-bar.manage-menu"
                                                        >
                                                            <span className=" d-flex align-items-center" data-testid="event-profile.admin-bar.manage-menu-btn">Manage <i className="uts uts-expand mr0" />
                                                            </span>
                                                        </PopOverMenu>
                                                    )}
                                                </div>

                                                {!event.data.published && (
                                                    <>
                                                        <span
                                                            type="button"
                                                            id="publish"
                                                            onClick={handlePublishClick}
                                                            data-testid="event-profile.admin-bar.publish-btn"
                                                        >
                                                            Publish
                                                        </span>
                                                        <Popover
                                                            placement="bottom"
                                                            isOpen={publishPopover}
                                                            target="publish"
                                                            toggle={togglePublishPopover}
                                                        >
                                                            <PopoverBody className={'publish-popover text-center p24 theme-v2'}>
                                                                <p className="text-bold text-dark" data-testid="event-profile.admin-bar.publish-popover-title">Ready to publish?</p>
                                                                <p className="text-small text-lighter" data-testid="event-profile.admin-bar.publish-popover-description">Players can view your
                                                                    event and register once registration is open.
                                                                </p>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-primary btn-lg text-uppercase mt8"
                                                                    onClick={handlePublishEvent}
                                                                    data-testid="event-profile.admin-bar.publish-confirm-btn"
                                                                >
                                                                    Publish event
                                                                </button>
                                                            </PopoverBody>
                                                        </Popover>
                                                    </>
                                                )}

                                                {showDrawsButton && (
                                                    <span
                                                        type="button"
                                                        className={`${styles.borderLeft}`}
                                                        onClick={handleNavigateToEventDesk}
                                                        data-testid="event-profile.admin-bar.event-desk-btn"
                                                    >
                                                        Event Desk
                                                    </span>
                                                )}
                                            </>
                                        )}
                                        {!!adminSplash &&
                                            <h6 data-testid="event-profile.admin-bar.splash-message">{adminSplash}</h6>}
                                    </>
                                )}
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            {deleteEventFailed && (
                <DeleteEventFailedPopup
                    close={() => dispatch(closeDeleteFailedPopup())}
                    unpublishEvent={() => {
                        dispatch(closeDeleteFailedPopup());
                        handleHeaderPopoverSelect({ value: 'unpublish' });
                    }}
                />
            )}
            {incompletePopup && (
                <IncompleteApplicationPopup
                    onSaveClick={() => setIncompletePopup(false)}
                    onCloseClick={() => setIncompletePopup(false)}
                    buttonText={`Got it`}
                />
            )}
            {canPublishRecurringFromProfile && (
                <RecurringSubmissionPopups
                    showPublishPopup={showRecurringPublishPopup}
                    recurringPublishSelection={recurringPublishSelection}
                    onConfirmPublish={handleConfirmRecurringPublish}
                    onCancelPublish={closeRecurringPublishPopup}
                    onConfirmSaveDraft={closeRecurringPublishPopup}
                    onCancelSaveDraft={closeRecurringPublishPopup}
                    onToggleSelectAll={toggleSelectAllRecurringPublish}
                    onToggleEvent={toggleRecurringPublishEvent}
                    timeZone={event.data?.eventSchedule?.timeZone || 77} // 'America/Los_Angeles'
                    isPrimaryPublished
                    primaryEvent={event.data}
                />
            )}
        </>
    );
};

AdminBarV3.propTypes = {
    isCurrentMemberAdmin: PropTypes.bool,
    isCurrentMemberVolunteer: PropTypes.bool,
    previewOnly: PropTypes.bool,
    toggleMessagePopUp: PropTypes.func,
    exportRegistrants: PropTypes.func,
    togglePlayerRegisterPopUp: PropTypes.func,
    toggleUploadAttachmentPopUp: PropTypes.func,
    toggleAddEligiblePlayersSidebar: PropTypes.func,
    toggleInvitePreRegistrantsSidebar: PropTypes.func,
    history: routerHistoryShape.isRequired,
};

AdminBarV3.defaultProps = {
    isCurrentMemberAdmin: false,
    isCurrentMemberVolunteer: false,
    previewOnly: false,
    toggleMessagePopUp: () => { },
    exportRegistrants: () => { },
    togglePlayerRegisterPopUp: () => { },
    toggleUploadAttachmentPopUp: () => { },
    toggleAddEligiblePlayersSidebar: () => { },
    toggleInvitePreRegistrantsSidebar: () => { },
};
export default withRouter(AdminBarV3);
